/**
 * NOTE: DO NOT EDIT nor ADD any config values to this file!
 * Any new required configurations should be added to the config.json file,
 * then update the AppConfig Interface config/config.type.ts file
 */

export const environment = {
  production: true
};
